const state = () => ({
  checklists: {},
});

const getters = {
  all: state => Object.keys(state.checklists).map(key => state.checklists[key]),
  get: state => state.checklists,
};

const mutations = {
  set(state, checklists) {
    checklists.forEach(checklist => {
      state.checklists[checklist.id] = checklist;
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
